module.exports = __webpack_public_path__ + "static/img/akum_800_65.c50d446.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_65.svg
// module id = 3TYl
// module chunks = 1